import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PendingPaymentInModel } from '../../Models/Models/Payments/Deposits/PendingPaymentInModel';

declare var IS_RUNNING_IN_APP_POOL;

export class PendingProductPaymentsInClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string): Promise<Array<PendingPaymentInModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/PendingProductPaymentsIn/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<Array<PendingPaymentInModel>, any>(url, data);
  }
}

